<template>
  <span class="substances-modal">
    <b-btn v-if="withButton" v-b-modal.substances-modal v-b-tooltip.hover size="sm" title="Редактор веществ"><i class="fa fa-flask fa-lg"></i> Вещества</b-btn>
    <b-modal id="substances-modal" dialog-class="modal-fullscreen-dialog" content-class="modal-fullscreen-content" hide-footer title="Редактор веществ">
      <substances />
    </b-modal>
  </span>
</template>

<style>
.substances-modal {
  position: absolute;
}

.modal-fullscreen-dialog {
  width: 100%;
  max-width: 100%;
  height: 100%;
  margin: 0;
  padding: 32px;
}

.modal-fullscreen-content {
  height: auto;
  min-height: 100%;
  border: 0;
  border-radius: 0;
}
</style>

<script>
import substances from "./substances/substances";
export default {
  name: "substancesModal",
  props: {
    withButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: true,
      progress: {
        modulation: false,
        calculation: false,
      },
    };
  },
  components: {
    substances,
  },
  created() { },
  methods: {
    modulation() {
      this.progress.modulation = true;
      this.$http
        .get("mapeditor/modulationthreadlinear", {
          params: {
            project_id: this.project.id,
          },
        })
        .then((response) => {
          this.$emit("update:zones", response.data);
          this.progress.modulation = false;
          // JSON responses are automatically parsed.
        })
        .catch(() => {
          this.$emit("update:zones", []);
          this.progress.modulation = false;
        });
    },
  },
};
</script>
